import { ref } from 'vue'
import { defineStore } from 'pinia'
import resource from '@/services/http/api/resource'
import type { ExclusionReason } from '@/types'
// @ts-expect-error: vuex
import { useStore } from 'vuex'

export const useResourceStore = defineStore('resourceStore', () => {
  const vuexStore = useStore()

  // state
  const loader = ref(false)
  const provinces = ref([])
  const schools = ref([])
  const consent = ref(null)
  const permissionedProvinces = ref([])
  const permissionedSchools = ref([])
  const childEditionExclusionReasons = ref<Array<ExclusionReason>>()

  const getProvinces = async () => {
    loader.value = true
    try {
      const { data } = await resource.provinces()
      provinces.value = data.data
    } finally {
      loader.value = false
    }
  }

  const getSchoolsPerProvince = async (provinceId: string) => {
    loader.value = true
    try {
      const { data } = await resource.schoolsPerProvince(provinceId)
      schools.value = data.data
    } finally {
      loader.value = false
    }
  }

  const getConsent = async (consentFormName: string) => {
    loader.value = true
    try {
      const { data } = await resource.consent(consentFormName)
      consent.value = data
    } finally {
      loader.value = false
    }
  }

  const getPermissionedProvinces = async () => {
    loader.value = true
    try {
      const { data } = await resource.permissionedProvinces()
      permissionedProvinces.value = data.data
      return data.data
    } finally {
      loader.value = false
    }
  }

  const getPermissionedSchoolsPerProvince = async (provinceId: string) => {
    loader.value = true
    try {
      const { data } = await resource.permissionedSchoolsPerProvince(provinceId)
      permissionedSchools.value = data.data
    } finally {
      loader.value = false
    }
  }

  const getChildEditionExclusionReasons = async () => {
    if (childEditionExclusionReasons.value) {
      return
    }

    vuexStore.commit('childEdition/setModalLoader', true)
    try {
      const { data } = await resource.excludeChildReasons()
      childEditionExclusionReasons.value = data.data
    } finally {
      vuexStore.commit('childEdition/setModalLoader', false)
    }
  }

  return {
    // state
    loader,
    provinces,
    schools,
    consent,
    permissionedProvinces,
    permissionedSchools,
    childEditionExclusionReasons,

    // actions
    getProvinces,
    getSchoolsPerProvince,
    getConsent,
    getPermissionedProvinces,
    getPermissionedSchoolsPerProvince,
    getChildEditionExclusionReasons
  }
})
